export default function roundTwoDecimal(value) {
  const result = Math.round(value * 100) / 100;
  return result;
}
